'use client';
import React, { ReactElement } from 'react';
import { CalendarPicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import Popover from '@mui/material/Popover';
import isToday from 'date-fns/isToday';
import fr from 'date-fns/locale/fr';
import { Button, Stack } from 'ui-components';
import { CALENDAR_SX } from '../date-range-picker/date-range-picker.constants';
import { DayCalendarPopoverProps } from './day-calendar-popover.props';
import { CALENDAR_VIEWS } from './day-calendar-popover.constants';

const DayCalendarPopover = (props: DayCalendarPopoverProps): ReactElement => {
  const { anchorEl, date, onClose, onSelectDay, onClear, popoverElevation } = props;
  const isOpen = Boolean(anchorEl);
  const isDateToday = Boolean(date) && isToday(date as Date);
  const canClear = Boolean(date) && Boolean(onClear);

  const handleCalendarChange = (day: Date | null) => {
    const isDaySelectable = Boolean(day);

    if (!isDaySelectable) return;

    onSelectDay(day as Date);
  };

  const handleSelectToday = () => {
    onSelectDay(new Date());
  };

  return (
    <Popover
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      elevation={popoverElevation}
      sx={CALENDAR_SX}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={fr}>
        <Stack>
          <CalendarPicker<Date> date={date} onChange={handleCalendarChange} views={CALENDAR_VIEWS} />
          <Stack direction="row" justifyContent="flex-end" spacing={1} px={2} pb={1}>
            {onClear && (
              <Button data-testid="clear-date-button" color="tertiary" size="small" disabled={!canClear} onClick={onClear}>
                Effacer la date
              </Button>
            )}
            <Button
              data-testid="today-button"
              color="tertiary"
              size="small"
              disabled={isDateToday}
              onClick={handleSelectToday}
            >
              Aujourd&apos;hui
            </Button>
          </Stack>
        </Stack>
      </LocalizationProvider>
    </Popover>
  );
};

export default DayCalendarPopover;
